import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const CANONICAL_DOMAIN = "https://bookrtutor.com";

const CanonicalTag = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const canonicalUrl =
      pathname === "/"
        ? `${CANONICAL_DOMAIN}/`
        : `${CANONICAL_DOMAIN}${pathname}`;

    let link = document.querySelector(
      'link[rel="canonical"]'
    ) as HTMLLinkElement | null;

    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }

    link.setAttribute("href", canonicalUrl);
  }, [pathname]);

  return null;
};

export default CanonicalTag;
